<div class="container">
  <div class="celo-dialog-header">
    <div matDialogTitle class="title">Description</div>
    <button
      mat-icon-button
      class="celo-dialog-close"
      aria-label="Close"
      id="close"
      mat-dialog-close
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content [innerHtml]="description | linkify"></mat-dialog-content>

  <mat-dialog-actions class="flex justify-end">
    <button class="celo-primary-button uppercase" mat-button matDialogClose>
      Done
    </button>
  </mat-dialog-actions>
</div>
